import React, { useEffect, useCallback, useState} from 'react';
import {getPresetsData} from "decentralized/presets/PresetsSearcher.js";
import Sample from "repos/Sample.js";
import ipfs from "decentralized/Ipfs.js";
import NewPackWindow from "components/packs/NewPackWindow.js";
import {getPacks} from "packs/packs.js";
import {searchPacks} from "components/packs/searchPacks.js";
import {connect} from 'react-redux';

const Packs = (props) => { 
    let [samples, setSamples] = useState([]);
    let [presets, setPresets] = useState(undefined);
    let [json, setJson] = useState(undefined);
    let [pack, setPack] = useState(undefined);

    useEffect(() => {
        if (pack) {
            ipfs.getJson(pack.packHash).then(
                setJson);
        }
    }, [pack, setJson]);

    useEffect(() => {
        searchPacks().then(
            packs => {
                setPack(packs.find(x => x.title === "synthz"));
            });
    }, [setPack]);

    useEffect(() => {
        if (!json) { return; }
        let _samples = [];
        let promises = [];
        for (let id of json.samples) {
            if (pack.matchingContent &&
                pack.matchingContent.length > 0 && 
                !pack.matchingContent.includes(id)) {
                continue;
            }
            let sample = new Sample(id);
            promises.push(sample.load());
            _samples.push(sample);
        }
        Promise.all(promises).then(
            x => setSamples(_samples));

        if (json.presets) {
            let _presets = json.presets;
            if (pack.matchingContent && pack.matchingContent.length > 0) {
                _presets = _presets.filter(
                    p => pack.matchingContent.includes(p));
            }
            getPresetsData(_presets)
                .then(setPresets);
        }
    }, [json, pack]);


    return (<div>
              {json && presets && <NewPackWindow setSave={props.setSave} track={props.track} sequencerEngine={props.sequencerEngine} json={{... json, ... pack, samples, presets}}/>}
            </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Packs);
